import { EditorSDK } from '@wix/platform-editor-sdk'; // Import EditorSDK type
import React from 'react';

const EditorSDKContext = React.createContext<EditorSDK | null>(null);

export const EditorSDKProvider = EditorSDKContext.Provider;

export default EditorSDKContext;
